import { DateTime } from 'luxon'

import { COMMUNITY_EVENTS_TOPIC } from '@/queries/constants'
import {
  ENRICHMENT_WORLD_SLUG,
  SCHOOLHOUSE_HUB_WORLD_SLUG,
} from '@/client/services/worlds/constants'
import { isProgramWorld } from '@/client/services/worlds/helpers'

import { SUMMER_CAMP_END_DATE, SUMMER_CAMP_LAUNCH_DATE, SUMMER_CAMP_START_DATE } from './constants'

export function hasSummerCampEnded(): boolean {
  return DateTime.now() >= SUMMER_CAMP_END_DATE
}

export function isSummerCampInProgress(): boolean {
  return DateTime.now() < SUMMER_CAMP_END_DATE && DateTime.now() >= SUMMER_CAMP_LAUNCH_DATE
}

export function isSummerCampInSession(): boolean {
  return DateTime.now() < SUMMER_CAMP_END_DATE && DateTime.now() >= SUMMER_CAMP_START_DATE
}

export function areSomeDatesDuringSummerCamp(dates: Date[]): boolean {
  return dates.some(
    date => date >= SUMMER_CAMP_START_DATE.toJSDate() && date <= SUMMER_CAMP_END_DATE.toJSDate()
  )
}

export function isSummerCampEligibleWorld(worldSlug: string | null): boolean {
  return worldSlug === ENRICHMENT_WORLD_SLUG || worldSlug === SCHOOLHOUSE_HUB_WORLD_SLUG
}

// A series is eligible for Summer Camp if it is either a) in the Enrichment or Hub subworld, or b) has all sessions marked with the Community Events topic
export function isSeriesEligibleForSummerCamp({
  worldSlug,
  sessionTopicNames,
  sessionDates,
  templateSlug,
}: {
  worldSlug: string | null
  sessionTopicNames: string[]
  sessionDates: Date[]
  templateSlug: string | null
}): boolean {
  // Exclude all series template series for simplicity, mostly relevant for Dialogues
  if (worldSlug == null || isProgramWorld(worldSlug) || templateSlug != null) {
    return false
  }

  if (!areSomeDatesDuringSummerCamp(sessionDates)) {
    return false
  }

  return (
    isSummerCampEligibleWorld(worldSlug) ||
    (sessionTopicNames.length > 0 &&
      sessionTopicNames.every(topicName => topicName === COMMUNITY_EVENTS_TOPIC))
  )
}
